import { FileListItem } from "@/components/IBFile/interface";
import NumberCore from "@/modules/NumberCore/NumberCore";
import { $downloadFile } from "../core/download-file";
import { FileObjectItem } from "./interface";

export const fileToBase64 = (
	file: File
): Promise<string> => new Promise(resolve => {
	const reader = new FileReader();

	reader.onload = () => resolve(reader.result as string || '');
	reader.onerror = () => resolve('');

	reader.readAsDataURL(file);
});

export const getFileItemByFileObject = (
	fileItems: FileListItem[],
	fileObject?: FileObjectItem | null,
): FileListItem => {
	const fileId = NumberCore.uniqueId;

	return {
		fileId,
		file: getFileByFileObject(fileObject),
		id: fileObject?.documentId || '',
		loadingPercent: 100,
		destroy: () => {
			const index = fileItems.findIndex(
				item => item.fileId === fileId
			);

			index > -1 && fileItems.splice(index, 1);
		},
		download: () => fileObject?.fileLink &&
			$downloadFile(
				fileObject.fileLink,
				fileObject?.fileName || 'file'
			)
	};
};

export const getFileByFileObject = (
	fileObject?: FileObjectItem | null
): File => {
	return {
		name: fileObject?.fileName || '',
		size: fileObject?.fileSize || 0,
		type: fileObject?.contentType || ''
	} as File;
};

export const mapFileObjectsToFileItems = (
	fileObjects?: FileObjectItem[] | null
): FileListItem[] => {
	const fileItems: FileListItem[] = [];

	if (fileObjects?.length) {
		for (const fileAttachment of fileObjects) {
			fileItems.push(
				getFileItemByFileObject(fileItems, fileAttachment)
			);
		}
	}

	return fileItems;
};